import Storage from "../storage/Storage";
import AxiosService from "../../services/axios-service/AxiosService";
import ManagerApiFeatureFlag from "../../utils/ManagerApiFeatureFlag";
import ErrorHandler from "../../utils/ErrorHandler";
import { OrganizationUser } from "../../models-v2/OrganizationUser";

const managerAPI = process.env.REACT_APP_MANAGER_API;

export default class OrganizationUserService {
    static async findByEmail(email: string): Promise<OrganizationUser> {
        let token, config;
        let organizationData;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
            organizationData = Storage.get(Storage.KEYS.ORGANIZATION_DATA);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        if (organizationData) {
            const orgData = JSON.parse(organizationData);
            const organizationId = orgData.id;
            config = {
                headers: {
                    Authorization: "Bearer " + token,
                    ...ManagerApiFeatureFlag.getNewManagerApiStorageConfig()
                },

                params: {
                    searchValue: email,
                    filter: "email"
                }
            };

            const path = `/organizations/${organizationId}/users`;

            const url = managerAPI + path;
            const resp = await AxiosService.httpGet(url, config);
            return resp.data[0];
        }

        throw new Error("Não foi possível recuperar os usuários");
    }

    static getOrgUserRoles = async () => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        const response = await AxiosService.httpGet(
            `${managerAPI}/organizations/role/org-admin`,
            config
        );

        return response.data;
    };

    static async updateUser(user: OrganizationUser): Promise<OrganizationUser> {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        const response = await AxiosService.httpPut(
            `${managerAPI}/organizations/users`,
            user,
            config
        );

        return response.data;
    }

    static async createOrganizationUser(
        user: OrganizationUser
    ): Promise<OrganizationUser> {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        const response = await AxiosService.httpPost(
            `${managerAPI}/organizations/users`,
            user,
            config
        );

        return response.data;
    }

    static async findUsersByOrganizationId(
        limit: number,
        page: number
    ): Promise<OrganizationUser> {
        let token, config;
        let organizationData;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
            organizationData = Storage.get(Storage.KEYS.ORGANIZATION_DATA);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        if (organizationData) {
            const orgData = JSON.parse(organizationData);
            let params = {};
            const organizationId = orgData.id;
            let path = `/organizations/${organizationId}/users`;
            let custumParams = {};
            if (page) {
                custumParams = {
                    ...params,
                    ...{ limit, page }
                };
            } else {
                custumParams = {
                    ...params,
                    ...{ limit }
                };
            }
            config = {
                headers: {
                    Authorization: "Bearer " + token,
                    ...ManagerApiFeatureFlag.getNewManagerApiStorageConfig()
                },

                params: custumParams
            };

            const url = managerAPI + path;
            const resp = await AxiosService.httpGet(url, config);
            return resp.data;
        }

        throw new Error("Não foi possível recuperar os usuários");
    }
}
